export default {"src":"/_next/static/media/description-plum-700.01709d5d.svg","height":20,"width":16,"blurWidth":0,"blurHeight":0};